// extracted by mini-css-extract-plugin
module.exports = {"wrap":"G5av","imgWrap":"G5abj","image":"G5ob","textBox":"G5abh","title":"G5al","statistics":"G5abn","viewsCount":"G5abp","commentsIcon":"G5pf","commentsCount":"G5abr"};